<style scoped lang="scss">

  .separator {
    text-align: center;
    font-size: 2.0rem;
    margin: 0 0 25px;

    p {
      margin: -1rem 0 0;
    }
  }
</style>

<template>
  <div class="separator">
    <p>...................</p>
  </div>
</template>

<script>
export default {
  name: 'Separator',
};
</script>
